import React, { useContext } from "react";
import teacherStyles from "../styles.module.css";
import styles from "./styles.module.css";
import { SocketContext } from "../../../../context/socketContext";
import avatar from "../../../../assets/icon/student.png";
import classroom from "../../../../assets/images/teacher_type.png";
import { createConversation } from "../../../../store/actions/conversations";
import { useWindowDimensions } from "../../../../utils/util";
import { getStudentData, getUpcomingClassForStudent, getStudentDashNums, getCurrentTeachers } from "../../../../store/actions/student";
import { getMeetingLink } from "../../../../store/actions/session";
import { getCourseById } from "../../../../store/actions/course";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { getTeacherDetailByTId } from "../../../../store/actions/teacher";

const StudentDashboard = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const socket = useContext(SocketContext);
    const { width } = useWindowDimensions();

    const [studentData, setStudentData] = React.useState();
    const [apiError, setApiError] = React.useState(null);
    const [profile, setProfile] = React.useState();
    const [msgFromT, setMsgFromT] = React.useState(false);
    const [upcomingClass, setUpcomingClass] = React.useState();
    const [languageUC, setLanguageUC] = React.useState();
    const [priceUC, setPriceUC] = React.useState();
    const [numbers, setNumbers] = React.useState();
    const [myTeachers, setMyTeachers] = React.useState([]);

    React.useEffect(() => {
        const handleNotification = d => d.role === "Teacher" && setMsgFromT(true);
        socket?.on("getNotification", handleNotification);
        return () => socket?.off("getNotification", handleNotification);
    }, [socket]);

    React.useEffect(() => {
        const userProfile = JSON.parse(localStorage.getItem("profile"));
        setProfile(userProfile);
        if (userProfile?._id) {
            socket?.emit("addUser", userProfile._id);
        }

        const init = async () => {
            if (!userProfile?._id) return;
            try {
                // Removed hardcoded admin conversation creation

                const studentId = userProfile.onType;
                if (!studentId) return;

                const res = await dispatch(getUpcomingClassForStudent(studentId));
                if (res?.data) {
                    setUpcomingClass(res.data);
                    const course = await dispatch(getCourseById(res.data.courseId));
                    setLanguageUC(course?.language?.data || "");
                    setPriceUC(course?.price?.data || 0);
                }

                const nums = await dispatch(getStudentDashNums(studentId));
                setNumbers(nums);

                const dataRes = await dispatch(getStudentData(userProfile._id));
                const myData = Array.isArray(dataRes) ? dataRes[0] : (dataRes?.data || dataRes);
                if (myData) {
                    setStudentData({ data: myData });
                }



                const teachersRes = await dispatch(getCurrentTeachers(studentId));
                if (teachersRes && Array.isArray(teachersRes)) {
                    const detailsPromises = teachersRes.map(async (tid) => {
                        try {
                            return await dispatch(getTeacherDetailByTId(tid));
                        } catch (e) {
                            return null;
                        }
                    });
                    const teachersDetails = await Promise.all(detailsPromises);
                    setMyTeachers(teachersDetails.filter(t => t));
                }
            } catch (e) {
                console.error("Dashboard initialization failed:", e);
                if (e.response?.status === 404) {
                    setApiError({
                        url: e.config?.url,
                        message: e.response?.data?.message || e.message
                    });
                }
            }
        };
        init();
    }, [dispatch, socket]);

    const handleJoinClass = async () => {
        if (!upcomingClass?._id) return;
        try {
            const res = await dispatch(getMeetingLink(upcomingClass._id));
            if (res?.success && res?.data?.meetingLink) {
                window.open(res.data.meetingLink, "_blank");
            } else {
                // If validation fails or link not found, alert the user
                alert(res?.message || "Class is not active yet. Please wait.");
            }
        } catch (err) {
            console.error("Failed to join class:", err);
            alert("Failed to join class. Please try again.");
        }
    };

    const handleMessage = async (teacherId) => {
        if (!profile?._id || !teacherId) return;
        try {
            const res = await dispatch(createConversation({
                senderId: profile._id,
                receiverId: teacherId
            }));

            let targetChat = res;
            if (res?.conv && Array.isArray(res.conv)) {
                targetChat = res.conv[0];
            }

            if (targetChat && targetChat.members) {
                navigate("/student/messages", { state: { cchat: targetChat } });
            } else {
                console.warn("Target chat invalid:", targetChat);
            }
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <main className={teacherStyles.mainSection}>
            {width >= 992 ? (
                <div className={styles.dashboardGrid}>
                    <div className={styles.leftColumn}>
                        {apiError && <ApiErrorBox error={apiError} />}
                        <div className={styles.banner}>

                            <div><div className={styles.welcomeText}>{`Welcome ${profile?.fullName || ""}`}</div></div>
                            <img src={classroom} alt="img" className={styles.bannerImg} />
                        </div>
                        <div className={styles.row}>
                            <SessionOverviewCard numbers={numbers} />
                            <TeacherCard teachers={myTeachers} onMessage={handleMessage} />
                        </div>
                    </div>
                    <div className={styles.rightColumn}>
                        <RightTeacherCard
                            studentData={studentData}
                            fromt={msgFromT}
                            setfromt={setMsgFromT}
                            upcomingClass={upcomingClass}
                            language={languageUC}
                            price={priceUC}
                            onJoin={handleJoinClass}
                        />
                    </div>
                </div>
            ) : (
                <>
                    {apiError && <ApiErrorBox error={apiError} />}
                    <div className={styles.mobileHeader}>{`Welcome ${profile?.fullName || ""}`}</div>

                    <MobileUpcomingCard
                        upcomingClass={upcomingClass}
                        language={languageUC}
                        price={priceUC}
                        onJoin={handleJoinClass}
                    />
                    <div className={styles.row} style={{ justifyContent: "space-between" }}>
                        <SessionOverviewCard numbers={numbers} />
                    </div>
                </>
            )}
        </main>
    );
};

const SessionOverviewCard = ({ numbers }) => (
    <div className={styles.sessions}><div className={styles.secondRowHeadings}>Sessions Overview</div><div className={styles.secondRowBody}><div><div>Book Session</div><div>Upcoming</div></div><div><div>{numbers?.booked}</div><div>{numbers?.upcoming}</div></div></div></div>
);



const TeacherCard = ({ teachers, onMessage }) => (
    <div className={styles.teacher}>
        <div className={styles.secondRowHeadings}>My Teachers</div>
        <div className={styles.secondRowBody}>
            {teachers && teachers.length > 0 ? (
                teachers.map((t, i) => {
                    const fName = t.firstName?.data || t.firstName || "Teacher";
                    const lName = t.lastName?.data || t.lastName || "";
                    const uId = t.userId?._id || t.userId || t._id;
                    return (
                        <div key={i} className={styles.teacherRow} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', alignItems: 'center' }}>
                            <div>
                                <div style={{ fontWeight: 600 }}>{fName} {lName}</div>
                                <div style={{ fontSize: '0.8rem', opacity: 0.7 }}>{t.courseName || "Course Instructor"}</div>
                            </div>
                            <button
                                className={styles.joinBtn}
                                style={{ width: 'auto', fontSize: '0.8rem', padding: '5px 10px' }}
                                onClick={() => onMessage(uId)}
                            >
                                Message
                            </button>
                        </div>
                    );
                })
            ) : (
                <div>No active teachers found.</div>
            )}
        </div>
    </div>
);

const ApiErrorBox = ({ error }) => (
    <div className={styles.errorBox}>
        <h4>⚠️ 404 Error Detected</h4>
        <div><strong>URL:</strong> {error.url}</div>
        <div><strong>Message:</strong> {error.message}</div>
        <div style={{ marginTop: '10px', fontSize: '0.8rem', opacity: 0.8 }}>The requested resource was not found on the server.</div>
    </div>
);




const RightTeacherCard = ({ studentData, fromt, froma, setfromt, setfroma, upcomingClass, language, price, onJoin }) => (
    <div className={styles.sidePanel}>
        <div className={styles.sidePanelInner}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div onClick={() => { setfromt(false); }}><i className="far fa-comment fa-2x" /></div>
            </div>
            <div style={{ textAlign: "center" }}>
                <img src={studentData?.data?.profilePic?.data || studentData?.data?.profilePic || avatar} alt="s" style={{ width: 150, height: 150, borderRadius: "50%", objectFit: "cover" }} />
                <div style={{ fontWeight: 600, marginTop: 10 }}>{studentData?.data?.firstName || "Student"}</div>
            </div>
            <div className={styles.upcomingClassBlock}>
                {upcomingClass ? (
                    <>
                        <div style={{ fontWeight: 700, fontSize: "1.1rem" }}>{language}</div>
                        <div>{moment(upcomingClass.from).format("DD MMM YYYY")}</div>
                        <div>{moment(upcomingClass.from).format("hh:mm A")}</div>
                        <div>{moment(upcomingClass.to).diff(moment(upcomingClass.from), "minutes")} Minutes</div>
                        <div style={{ fontSize: "1.2rem", fontWeight: 800 }}>${price}</div>
                        <button onClick={onJoin} className={styles.joinBtn}>Join Class</button>
                    </>
                ) : <div style={{ textAlign: "center", padding: 20 }}>No meetings to show</div>}
            </div>
        </div>
    </div>
);

const MobileUpcomingCard = ({ upcomingClass, language, price, onJoin }) => (
    <div className={styles.mobileUpcoming}>
        {upcomingClass ? (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                    <div style={{ fontWeight: 700 }}>{language}</div>
                    <div style={{ fontSize: "0.8rem", opacity: 0.9 }}>{moment(upcomingClass.from).format("DD MMM, hh:mm A")}</div>
                    <div style={{ fontWeight: 800 }}>${price}</div>
                </div>
                <button onClick={onJoin} className={styles.joinBtn} style={{ width: "auto", padding: "8px 15px" }}>Join Now</button>
            </div>
        ) : <div style={{ textAlign: "center" }}>No meetings to show</div>}
    </div>
);


export default StudentDashboard;
